/*
We are aware this is a discouraged pattern, and we use it here as a last resort.

The motivating problem to solve is that Google's static security analysis on Chrome
extensions is rejecting HubSpot's Sales extension if it imports hubspot-prosemirror.
They can detect that we append a script tag and set the src to a 3rd-party website.

We have to completely strip that code from our bundle. The VidYard code is very
tightly coupled right now, so a proper plugin approach would require a deep refactor.

This abuses globals and runtime behavior to get the code out of our bundle without
consumers having to change much. One new line to import, instead of a lot of plugin
initialization code to write.

Sorry this is ugly! This work was done in haste to unblock a team.

- @azerilli Jan 12 2026
*/

import { FloatingAlertStore } from 'foundations-components/transitional/components/FloatingAlertList';
import I18n from 'I18n';
import Raven from 'raven-js';
const VIDYARD_NOT_CONFIGURED_ERROR = `
Vidyard SDK is not configured. To use Vidyard video recording, add this import to your application:

  import 'hubspot-prosemirror-plugins/vidyard';

This import must run before the video dialog is opened.
`;
if (typeof window !== 'undefined' && !window.__hsLoadVidyardScript) {
  window.__hsLoadVidyardScript = () => {
    FloatingAlertStore.addAlert({
      titleText: I18n.text('draftPlugins.videoPlugin.unavailableAlert.title'),
      message: I18n.text('draftPlugins.videoPlugin.unavailableAlert.message'),
      type: 'danger'
    });
    const error = new Error(VIDYARD_NOT_CONFIGURED_ERROR);
    Raven.captureException(error);
    throw error;
  };
}
export function loadVidyardScript() {
  var _hsLoadVidyardScript, _ref;
  (_hsLoadVidyardScript = (_ref = window).__hsLoadVidyardScript) === null || _hsLoadVidyardScript === void 0 || _hsLoadVidyardScript.call(_ref);
}